import Box from '@/components/UI/box/Box';
import Divider from '@/components/UI/divider/Divider';
import { useRouter } from 'next/router';
import { memo } from 'react';
import styles from './Pagination.module.scss';
import Skeleton from '@/components/UI/skeleton/Skeleton';
import Pagination from '@/components/UI/pagination/Pagination';
const Paginations = ({
  perPage,
  data
}) => {
  const router = useRouter();
  // const { setQuery } = useSearchParams()
  const hasNoResult = !data.loading && !data.list?.length;
  const pages = Number(Math.ceil(data.pagination?.total / perPage));
  // const handlePageChange = (_: React.ChangeEvent<unknown>, page: number) => {
  //   setQuery({ page })
  // }

  if (!pages) {
    return null;
  }
  return <>
      {!hasNoResult && <>
          {!data.loading ? <Box>
              <Box component={'nav'} aria-label="pagination navigation" className={styles['pagination-container']}>
                <Pagination totalPages={pages} currentPage={Number(router.query?.page) > 1 ? Number(router.query?.page || 1) : 1} />
              </Box>
            </Box> : <Box className={styles['pagination-skeleton-container']}>
              <Skeleton variant="rectangular" height={20} className={styles['pagination-skeleton']} />
            </Box>}
        </>}
      <Box className={styles['pagination-divider']} data-sentry-element="Box" data-sentry-source-file="Pagination.tsx">
        <Divider data-sentry-element="Divider" data-sentry-source-file="Pagination.tsx" />
      </Box>
    </>;
};
export default memo(Paginations);